import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { DatePicker } from '@/kit/form/DatePicker';
import { RoundButton } from '@/components/UI/RoundButton';
import { InputTextField } from '@/components/UI/InputTextField';
import './index.scss';

const VALIDATION_SCHEMA = t =>
  Yup.object({
    start_date: Yup.mixed().required(t('profile_education_form.start_date_required')),
    college: Yup.string().required(t('profile_education_form.college_required')),
    degree: Yup.string(),
  });

const ProfileEducationForm = ({ education, onSubmit, onRemove }) => {
  const { t } = useTranslation('components');

  return (
    <Formik
      enableReinitialize
      validationSchema={VALIDATION_SCHEMA(t)}
      initialValues={{
        college: education ? education.college : '',
        degree: education ? education.degree : '',
        start_date: education?.start_date ? new Date(education.start_date) : null,
        end_date: education?.end_date ? new Date(education.end_date) : null,
      }}
      onSubmit={(values, formikBag) => onSubmit(values, formikBag)}
    >
      {({ values, setFieldValue, errors, touched, handleChange, handleSubmit }) => (
        <form className="profile-education-form" onSubmit={handleSubmit}>
          <h1 className="profile-education-form__title f-32 f-500">
            {education
              ? t('profile_education_form.edit_education')
              : t('profile_education_form.add_new_education')}
          </h1>
          <div className="education-item">
            <div className="education-item__dates">
              <DatePicker
                name="start_date"
                label={t('profile_education_form.start_date')}
                value={values.start_date}
                onChange={date => setFieldValue('start_date', date)}
                onReset={() => setFieldValue('start_date', null)}
              />
              <DatePicker
                name="end_date"
                label={t('profile_education_form.end_date')}
                value={values.end_date}
                onChange={date => setFieldValue('end_date', date)}
                onReset={() => setFieldValue('end_date', null)}
              />
            </div>
            <InputTextField
              label={t('profile_education_form.college')}
              name="college"
              onChange={handleChange}
              value={values.college}
              error={errors.college && touched.college && errors.college}
              className="profile-education-form__field"
            />

            <InputTextField
              label={t('profile_education_form.degree')}
              onChange={handleChange}
              value={values.degree}
              name="degree"
              error={errors.degree && touched.degree && errors.degree}
              className="profile-education-form__field"
            />
          </div>

          <div className="profile-education-form__buttons">
            {!!education && (
              <RoundButton
                label={t('profile_education_form.remove')}
                type="button"
                onClick={onRemove}
                fullWidth
                className="profile-education-form__button"
              />
            )}
            <RoundButton
              label={
                education ? t('profile_education_form.update') : t('profile_education_form.add')
              }
              type="submit"
              onSubmit={handleSubmit}
              fillBackground
              fullWidth
              className="profile-education-form__button"
            />
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ProfileEducationForm;
